/**
 * Checks if a value is empty.
 * - Arrays: empty if length === 0
 * - Objects: empty if no own enumerable keys
 * - null/undefined: considered empty
 * - Strings: empty if length === 0 after trimming whitespace
 */
export const isEmpty = (value: unknown): boolean => {
  if (value == null) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};
